import GET from "./api/GET";

export const fetchNotifications = async () => {
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/notification/get`
  );
  return response;
};